import { TitleBoxTypography } from '@/admins/SmartReports/components/Layouts/components/TitleBoxTypography';
import { SlotsEnum } from '@/admins/SmartReports/components/Layouts/TitlePage/types';
import { PlaceholderPreview } from '@/admins/SmartReports/components/Placeholders/Placeholder';
import { SlotEdit } from '@/admins/SmartReports/components/Slots/SlotEdit';
import { SlotView } from '@/admins/SmartReports/components/Slots/SlotView';
import { SmartReportComponentTypesEnum } from '@/admins/SmartReports/types';
import { Root, RootForThumbnail, TitleBox } from './components';

const styles = {
  titleBox: {
    marginBottom: '0',
  },
  emptySlotPreview: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    boxSizing: 'border-box',
    height: '100%',
  },
};

const getRowKey = (rowIndex, slotIndex) => `row_${rowIndex}_slot_${slotIndex}`;

export const BaseRowEdit = ({ layout, rootStyles }) => {
  return (
    <Root sx={rootStyles}>
      <TitleBox sx={styles.titleBox}>
        <TitleBoxTypography sx={{ padding: 0 }}>
          <SlotEdit slotId={SlotsEnum.Title} accept={[SmartReportComponentTypesEnum.TextField]} />
        </TitleBoxTypography>
      </TitleBox>

      {layout.map((row, rowIdx) =>
        row.map((_, slotIdx) => (
          <SlotEdit
            slotId={getRowKey(rowIdx, slotIdx)}
            accept={Object.values(SmartReportComponentTypesEnum)}
            key={getRowKey(rowIdx, slotIdx)}
          />
        )),
      )}
    </Root>
  );
};

export const BaseRowView = ({ entity, pageData, rootStyles, layout, ...props }) => {
  return (
    <Root sx={rootStyles}>
      <TitleBox sx={styles.titleBox}>
        <TitleBoxTypography>
          <SlotView slotId={SlotsEnum.Title} entity={entity} pageData={pageData} />
        </TitleBoxTypography>
      </TitleBox>
      {layout.map((row, rowIdx) =>
        row.map((_, slotIdx) => (
          <SlotView
            key={getRowKey(rowIdx, slotIdx)}
            slotId={getRowKey(rowIdx, slotIdx)}
            entity={entity}
            pageData={pageData}
            {...props}
          />
        )),
      )}
    </Root>
  );
};

export const BaseRowThumbnail = ({ rootStyles, layout, ...props }) => {
  return (
    <RootForThumbnail {...props} sx={{ ...rootStyles, ...(props.sx || {}) }}>
      <TitleBox sx={{ marginBottom: '0', paddingBottom: '0', minHeight: 'unset' }}>
        <TitleBoxTypography sx={{ fontSize: '0.3rem', paddingBottom: '0' }}>
          Untitled
        </TitleBoxTypography>
      </TitleBox>

      {layout.map((row, rowIdx) =>
        row.map((_, slotIdx) => <PlaceholderPreview key={getRowKey(rowIdx, slotIdx)} />),
      )}
    </RootForThumbnail>
  );
};
